import { jsx as _jsx } from "react/jsx-runtime";
import { APPLICANT_GROUP_FIELD, } from "@aidkitorg/types/lib/admin-panel/filters";
import { cn } from "../utils/tailwind";
import { useLocalizedStrings } from "../LocalizationProvider";
import { renderFilterGroup } from "./filterDisplay";
import { useFilterOperators } from "./common";
export const FilterBadges = ({ config, availableFields = [], showApplicantGroupField = true, className, onRemoveCondition, formatFilterValue, }) => {
    const L = useLocalizedStrings();
    const { FILTER_OPERATOR_LABELS } = useFilterOperators();
    if (!config?.enabled || !config.config?.conditions?.length)
        return null;
    const fieldLabels = {};
    for (const field of availableFields) {
        fieldLabels[field.key] = field.label;
    }
    if (showApplicantGroupField) {
        fieldLabels[APPLICANT_GROUP_FIELD.key] = APPLICANT_GROUP_FIELD.label;
    }
    const badges = renderFilterGroup(config.config, fieldLabels, false, 'default', {
        operatorLabels: FILTER_OPERATOR_LABELS,
        and: L.component_library.filter_panel.and,
        or: L.component_library.filter_panel.or,
        formatValue: formatFilterValue,
    }, onRemoveCondition);
    if (badges.length === 0)
        return null;
    return (_jsx("div", { className: cn("flex flex-wrap items-center gap-2", className), children: badges }));
};
